import { get as getCookie, set as setCookie } from "es-cookie";

import WebKeys from "./core/WebKeys";

/** Tipos de escala válidos. */
type Scale = "default" | "large";

/**
 * Referencia a los elementos que hacen de controles en la web para aumentar y
 * reducir el texto.
 */
const controls = {
  enlarge: $(),
  reduce: $(),
};

/**
 * Nombre del evento que se lanza al modificar la fuente.
 * Vamos por eventos javascript. No puedmos registrar internamente en el módulo
 * porque no hay una instancia única. Según desde dónde se importa, podemos
 * tener varias instancias. Al menos, tal cual está montado ahora.
 */
const SCALE_FONT_EVENT_NAME = "fsctrl.update";

/** Array de tipos válidos. Se usa para validar al recupear la cookie. */
const availableScales = ["default", "large"];

/**
 * Agranda el texto de la página, siempre que no se esté ya en el tamaño máximo.
 */
function enlargeText() {
  const current = retriveScale();

  /* Ahora mismo únicamente hay dos valores: default y large. */
  if (current === "default") {
    updateScale("large");
  }
}

/**
 * Reduce el texto de la página, siempre que no se esté ya en el tamaño mínimo.
 */
function reduceText() {
  const current = retriveScale();

  /* Ahora mismo únicamente hay dos valores: default y large. */
  if (current === "large") {
    updateScale("default");
  }
}

/** Recupera el tamaño de la fuente actual */
function retriveScale() {
  const value = getCookie(WebKeys.COOKIES_FONT_SCALE);

  return $.inArray(value, availableScales) !== -1 ? (value as Scale) : "default";
}

/** Guarda el tamaño de fuente seleccionado */
function storeScale(value: Scale) {
  setCookie(WebKeys.COOKIES_FONT_SCALE, value, { path: "/" });
}

/** Actualiza la fuente a la escala indicada. */
function updateScale(scale: Scale) {
  const html = $("html");
  html.removeClass("ims-large-text font-large");

  if (scale === "large") {
    html.addClass("ims-large-text font-large");
  }

  controls.enlarge.prop("disabled", scale === "large");
  controls.reduce.prop("disabled", scale === "default");

  storeScale(scale);
  html.trigger(SCALE_FONT_EVENT_NAME);
}

/**
 * Registra una función que se invacará cada vez que se cambia el tamaño de la
 * fuente. La función indicada recibe como primer parámetro el tamaño aplicado.
 */
export function registerListener(listener: () => void): void {
  $("html").on(SCALE_FONT_EVENT_NAME, listener);
}

/**
 * Inicializa los controles sobre los objetos indicados.
 *
 * @param reduceControlId Id html del elemento para reducir el texto
 * @param enlargeControlId id html del elemento para aumentar el texto
 */
export default function initialize(reduceControlId: string, enlargeControlId: string): void {
  controls.reduce = $(`#${reduceControlId}`).on('click', reduceText);
  controls.enlarge = $(`#${enlargeControlId}`).on('click', enlargeText);

  /* Carga inicial. */
  const scale = retriveScale();
  if (scale !== "default") {
    updateScale(scale);
  }
}
